import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Lifecycle } from 'src/app/_helpers/Lifecycle/Lifecycle.class';
import { APIHeaderService } from '../../_services/header/API-header';
import { formatDate } from '@angular/common';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { FormGroup, FormControl, NgForm,ReactiveFormsModule } from '@angular/forms';
//import { FormGroup, FormControl, NgForm,ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators, FormArray, FormControlName, NgModel } from '@angular/forms';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient } from '@angular/common/http';


const today = new Date();
var time_today = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
declare var require: any
let dateFormat = require('dateformat');
const currentdatee = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
@Component({
  selector: 'app-header-voice-summary',
  templateUrl: './header-voice-summary.component.html',
  styleUrls: ['./header-voice-summary.component.css']
})
export class HeaderVoiceSummaryComponent extends Lifecycle {

  newHeaders: number[] = [];
  newSummaries: number[] = [];
  rootHeaders: any[];
  allrootHeaders: any;
  allHeaders:any;
  allRootHeadersForApp: any;
  allHeadersForApp:any;
  allRootHeadersForTSP: any;
  allHeadersForTSP: any;
  headerId: any;
  public principalEntityId: any;
  public entityRefNo: any;
  public role: any;
  newHeaderSummary: any;
  allHeaderSummary: any;
  param: any;
  principalEntityName: any;
  filterData:any;
  allHeadersVoiceForApp: any;
  pricipleEntityHeaderVoiceDLT: any;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
   @ViewChild('t1Sort') t1Sort: MatSort;
  @ViewChild('t2Sort') t2Sort: MatSort;
  @ViewChild('t3Sort') t3Sort: MatSort;
  @ViewChild('t4Sort') t4Sort: MatSort;
 numbersOfMatSort = 0;
  dataSubject = new BehaviorSubject<any[]>([]);
 // displayedColumns: string[] = ['H_PrincipalEntityId', 'TSP_Name', 'Header_Name', 'PrincipalEntityId', 'H_Register_Date', 'Hash_KYC_Doc', 'Approve', 'Reject'];
  displayedColumns: any[] = [
     'Header_Name' ,'PrincipalEntityId', 'H_Register_Date', 'Hash_KYC_Doc',

  ];
 // displayedColumns1: string[] = ['RH_PrincipalEntityId', 'TSP_Name', 'RH_Created_By', 'RH_Register_Date', 'Approve', 'Reject'];
 displayedColumns1: any[] = [
  'RH_PrincipalEntityId', 'TSP_Name'  ,'RH_Created_By', 'RH_Register_Date', 
  { def: 'Approve', showMobile: false },
  { def: 'Reject', showMobile: false },
]; 
 displayedColumns2: any[] = ['cli', 'createdBy', 'createdAt', 'sts', 
   { def: 'Approve', showMobile: false },
   { def: 'Reject', showMobile: false },
  ];
  displayedColumns3: any[] = ['cli', 'PrincipalEntityId', 'uts', 'sts',
  { def: 'Active', showMobile: false },
  ];
 
  dataSource: MatTableDataSource<any>;
  noRecord: any;
  dataSource1: MatTableDataSource<any>;
  noRecord1: any;
  dataSource2: MatTableDataSource<any>;
  noRecord2: any;
  dataSource3: MatTableDataSource<any>;
  noRecord3: any;
  
  form: any = {};
  form1: any = {};
  form2: any = {};
  form3: any={};
  entityRole = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ROLE);
  getDisplayedColumns(): string[] {
    
    //const isMobile = this.entityRole === 'Network Adminstrator' || 'Operations User';
     const isMobile = this.entityRole != 'Application Adminstrator';
    let a = this.displayedColumns2
      .filter(cd => !isMobile || cd['showMobile'] !== false)
      .map(cd => typeof cd === 'string' ? cd : cd.def);
  
     return a;
   }

   getDisplayedColumns1(): string[] {
    
    //const isMobile = this.entityRole === 'Network Adminstrator' || 'Operations User';
    const isMobile = this.entityRole != 'Application Adminstrator';
    let a = this.displayedColumns1
      .filter(cd => !isMobile || cd['showMobile'] !== false)
      .map(cd => typeof cd === 'string' ? cd : cd.def);
 
      return a;
   }
   getDisplayedColumns3(): string[] {
    
    //const isMobile = this.entityRole === 'Network Adminstrator' || 'Operations User';
    const isMobile = this.entityRole != 'Application Adminstrator';
    let a = this.displayedColumns3
      .filter(cd => !isMobile || cd['showMobile'] !== false)
      .map(cd => typeof cd === 'string' ? cd : cd.def);
 
      return a;
   }


  constructor(
    private http: HttpClient,
    private hs: APIHeaderService,
    private db: $DBManagerService,
    private formBuilder: FormBuilder,
    private $modal: $ModalManagerService) {
    super();
    }
    //filterForm: FormGroup;

  _initialize() {

    this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.principalEntityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
    this.entityRefNo = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
    this.role = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
    this.headerId = this.db.get(Constants.SESSSION_STORAGE, Constants.HEADER_ID);

    this.getAllHeaderVoiceForApproval();
	this.getAllHeaderVoiceFromDLT();

  }

  applyFilter(filterValue1: string) {
    this.dataSource.filter = filterValue1.trim().toLowerCase();
  }

  onApplyFilter(filterForm) {
    //console.log("inn");
    console.log("inn",filterForm);
    // let searchParam = this.filterForm.get("search").value;
    // let fdate = this.filterForm.get("startDate").value;
    // let todate =this.filterForm.get("endDate").value;
    // console.log("searchParam"+searchParam);

    console.log("inn2");
    console.log("serch",filterForm.search);
   console.log("2nd",filterForm.endDate);
    console.log("3rd",filterForm.startDate);

    const fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    console.log("fdate",fdate);
    console.log("ldate",ldate);
   // console.log("rd3",filterForm.endDate.value);
   this.getAllUnapprovedHeaderFilter(filterForm.search,fdate,ldate);
  }

  onApplyFilter1(filterForm1) {
    console.log("salform1");
    console.log(filterForm1.value);
    const fdate = formatDate(filterForm1.startDate1, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm1.endDate1, 'yyyy-MM-dd', 'en-US', '+0530');
    this.getAllUnapprovedRootHeaderFilter(filterForm1.search1,fdate,ldate);

  }

  onApplyFilter2(filterForm2) {
    console.log("32rd",filterForm2.value);
    console.log("inn  allHeaders");
    const fdate = formatDate(filterForm2.startDate2, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm2.endDate2, 'yyyy-MM-dd', 'en-US', '+0530');

    this.getAllHeadersFilter(filterForm2.search2,fdate,ldate);
  }

  onApplyFilter3(filterForm3) {
    console.log("lastForm",filterForm3.value);
    const fdate = formatDate(filterForm3.startDate3, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm3.endDate3, 'yyyy-MM-dd', 'en-US', '+0530');
    this.getAllRootHeadersFilter(filterForm3.search3,fdate,ldate);

  }

   //MAke Active/Inactive Header
 
 makeActiveInactiveHeader(id,cli,sts){
	
	 if(sts == "A"){
		 let H_PrincipalEntityId = id;
		// this.rejectVoiceHeader(id,cli);
		     var data = {
      "sts": "I",
       "id": id,
	   "entity_id": this.principalEntityId,
	    "cli": cli
    };
    console.log("data............... ", data);

    this.allHeadersForApp = this.allHeadersForApp.data.filter(function (val, i) {
      console.log("The value is ",val)
      return val._id !== id;
    });

    this.onChangeDataSource1(this.allHeadersForApp);

    this.hs.UpdateStatusHeaderVoice(data)
      .subscribe(r => {
       
        if (r.status == true) {
          this.$modal.errorModal({
            title: 'Header Inactive',
            msg: 'Header has been set as Inactive '
          });

        }
    this.getAllHeaderVoiceForApproval();
    this.getAllHeaderVoiceFromDLT();

    })
	 }
	 else{
		 //this.approveVoiceHeader(id,cli);
     var data = {
      "sts": "A",
      "id": id,
  "entity_id": this.principalEntityId,
  "cli": cli
};
console.log("this.newHeaderSummary.data............... ", this.allHeadersForApp.data);


this.allHeadersForApp = this.allHeadersForApp.data.filter(function (val, i) {
  return val._id !== id;
});
console.log("this.newHeaderSummary ____ : ",this.allHeadersForApp);
this.onChangeDataSource1(this.allHeadersForApp);


this.hs.UpdateStatusHeaderVoice(data)
  .subscribe(r => {

   
    if (r.status == true) {
     
      this.$modal.successModal({
        title: 'Header Activation',
        msg: 'Header has been set as active'
      });

    }
this.getAllHeaderVoiceForApproval();
this.getAllHeaderVoiceFromDLT();
  })
// this.APIgetNewHeaderSummary();
	 }
 }
 
 

  getAllNewRootHeader() {
    //this.hs.getAllNewRootHeaders()
     // .subscribe(m => {

       // this.allrootHeaders = m;
     // });


  }

  getAllHeaderVoiceForApproval() {
     if(this.role == "Tata Employee"){
	 let a = "P";
      this.hs.ListHeaderVoice(a).
    subscribe(value =>
      { 
        this.allHeadersForApp = value;
	    console.log("allHeadersForApp ___",value);
        this.onChangeDataSource1(this.allHeadersForApp.data);
		
      });
	 }
	 else if(this.role == "PE"){ 
	   let data = {
			"peid" : this.principalEntityId
		}
	   this.hs.ListPrincipalEntityHeaderVoice(data).
    subscribe(value =>
      { 
        this.allHeadersForApp = value;
	    console.log("allHeadersForApp ___",value);
        this.onChangeDataSource1(this.allHeadersForApp.data);
		
      });
	 }
	 else if(this.role == "TM"){ 
		let data = {
			"tmid" : this.principalEntityId
		}
		this.hs.ListTelemarketerEntityHeaderVoice(data).
			subscribe(value =>
      { 
        this.allHeadersForApp = value;
	    console.log("ListTelemarketerEntityHeaderVoice ___",value);
        this.onChangeDataSource1(this.allHeadersForApp.data);
		
      });
	 }
	 
  }

  getAllHeaderVoiceFromDLT(){
	
	if(this.role == "Tata Employee"){
	this.hs.listHeaderVoiceDLT(this.principalEntityId).
    subscribe(value =>

      { 
        this.allHeadersVoiceForApp = value;
	    console.log("allHeadersVoiceForApp ___",this.allHeadersVoiceForApp.data);
        this.onChangeDataSource2(this.allHeadersVoiceForApp.data);
		
      });
	}
	   else if(this.role == "PE"){ 
		  
		this.hs.ListPricipleEntityHeaderVoiceDLT(this.principalEntityId).
		subscribe(valuee =>
      { 
        this.allHeadersVoiceForApp = valuee;
	    console.log("ricipleEntityHeaderVoiceDLT ___",this.allHeadersVoiceForApp.data);
        this.onChangeDataSource2(this.allHeadersVoiceForApp.data);
		
      }); 
		  
	  }
	  
	  else if(this.role == "TM"){ 
		  
		this.hs.ListTeleEntityHeaderVoiceDLT(this.principalEntityId).
		subscribe(valuee =>
      { 
        this.allHeadersVoiceForApp = valuee;
	    console.log("ricipleEntityHeaderVoiceDLT ___",this.allHeadersVoiceForApp.data);
        this.onChangeDataSource2(this.allHeadersVoiceForApp.data);
		
      }); 
		  
	  }
	  
  }
  
  
  onChangeDataSource1(value) {
    this.dataSource1 = new MatTableDataSource(value);
	this.dataSource1.paginator = this.paginator.toArray()[0];
    this.dataSource1.sort = this.t1Sort;
    this.noRecord = this.dataSource1.connect().pipe(map(data => data.length === 0));
  }

  onChangeDataSource2(value) {
    this.dataSource2 = new MatTableDataSource(value);
	this.dataSource2.paginator = this.paginator.toArray()[1];
    this.dataSource2.sort = this.t2Sort;
    this.noRecord2 = this.dataSource2.connect().pipe(map(data => data.length === 0));
  }

  rejectApproveHeader(Header_ID) {
    console.log("this.principalEntityId : ", this.principalEntityId);
    var data = {
		
		   "sts": "A",
           "id": Header_ID,
           "entity_id": this.principalEntityId,
         
    };

    this.allHeadersForApp = this.allHeadersForApp.filter(function (val, i) {
      return val.Key !== Header_ID;
    });

    this.onChangeDataSource1(this.allHeadersForApp);

    this.hs.UpdateStatusHeaderVoice(data)
      .subscribe(r => {
        let HeaderResponse = {
          'Key': Header_ID,
          'Record': r.status
        }
        console.log("HeaderResponse :", HeaderResponse);
        console.log("headerrr before :", this.allHeaders);
        // this.allRootHeadersForTSP.push(rootHeaderResponse)
        console.log("allHeadersForTSP :", this.allHeadersForTSP);
        if (r.status == "success") {
          this.$modal.errorModal({
            title: ' Header voice Registration',
            msg: 'Header voice has been Rejected '
          });

        }
      })
  }

  APIgetNewHeaderSummary() {
    // this.hs.ListHeaderSMS().
    // subscribe(value =>
      // { 
      //   this.newHeaderSummary = value.data; 
      //   this.onChangeDataSource(this.newHeaderSummary);
		
      // });
    /* this.hs.getNewHeaderSummary("TATA")
      .subscribe(value => {
        this.newHeaderSummary = value;
        this.onChangeDataSource(this.newHeaderSummary);
      }); */
  }
 
  getAllActiveHeader(){
  
  }
   
  /* onChangeDataSource(value) {
    //this.dataSource = new MatTableDataSource(value);
	this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  } */

  APIgetAllHeaderSummaries() {
    this.principalEntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    if (this.role == "Tata Employee") {
      this.param = this.role;
    }
    else {
      this.param = this.principalEntityId;
      console.log("this.principalEntityId .. ", this.principalEntityId);
    }
    this.hs.ListRootHeaderSMSActive(this.role).subscribe(value =>
      {
        this.dataSource2 = new MatTableDataSource(value);
        this.dataSource2.paginator = this.paginator.toArray()[1];
        this.dataSource2.sort = this.t3Sort;
        this.noRecord2 = this.dataSource2.connect().pipe(map(data => data.length === 0));
      });
    this.hs.getAllHeaderSummary(this.role, this.param)
      .subscribe(value => {
        this.dataSource2 = new MatTableDataSource(value);
        this.dataSource2.paginator = this.paginator.toArray()[1];
        this.dataSource2.sort = this.t3Sort;
        this.noRecord2 = this.dataSource2.connect().pipe(map(data => data.length === 0));
      });
  }






  getAllUnapprovedHeaderFilter(param1,fdate,todate){
    console.log("inside main function ");

    console.log("inside main function "+param1+"$$$"+fdate+"$$$$"+todate);
    this.hs.getAllUnApprovedHeadersFilter(param1,fdate,todate)
    .subscribe(r => {
      this.filterData = r;
      this.dataSource = r;
      console.log("12345 :", this.filterData);
    })

  }
 //Approve Header
  approveVoiceHeader(H_PrincipalEntityId,cli) {
    var data = {
          "sts": "A",
          "id": H_PrincipalEntityId,
		  "entity_id": this.principalEntityId,
		  "cli": cli
    }
    
   
   console.log("this.allHeadersForApp ____ ",this.allHeadersForApp);
   this.allHeadersForApp = this.allHeadersForApp.data.filter(function (val, i) {
	  //  console.log("this is is val",val);
	console.log("The removed entity is ",H_PrincipalEntityId)
      return val.H_PrincipalEntityId !== H_PrincipalEntityId;
    });
   //console.log("this.newHeaderSummary ____ : ",this.allHeadersForApp);
   this.onChangeDataSource1(this.allHeadersForApp);

  //  this.getAllHeaderVoiceForApproval();
  console.log("hello id",data)
  console.log("Approval is happening");
		this.getAllHeaderVoiceFromDLT();
    this.hs.UpdateStatusHeaderVoice(data)
      .subscribe(r => {

       
        if (r.status == true) {
         
          this.$modal.successModal({
            title: 'Header Registration',
            msg: 'Header has been Approved'
          });
 // this.APIgetNewHeaderSummary(); 
	 console.log("this.newHeaderSummary.data............... i wrote this ", this.allHeadersForApp);
		this.getAllHeaderVoiceForApproval();
		this.getAllHeaderVoiceFromDLT();
        }
        else{
          this.$modal.errorModal({
            title: 'Header Registration',
            msg: r.message
          });
        }
		
      })
	
  }

  //Approve Header
  rejectVoiceHeader(H_PrincipalEntityId,cli) {
    var data = {
      "sts": "R",
       "id": H_PrincipalEntityId,
	   "entity_id": this.principalEntityId,
	    "cli": cli
    };
    console.log("data............... ", data);

    // this.allHeadersForApp = this.allHeadersForApp.data.filter(function (val, i) {
    //   return val._id !== H_PrincipalEntityId;
    // });

    this.onChangeDataSource1(this.allHeadersForApp);

    this.hs.UpdateStatusHeaderVoice(data)
      .subscribe(r => {
       
        if (r.status == true) {
          this.$modal.errorModal({
            title: 'Header Registration',
            msg: 'Header has been Rejected '
          });

        }
		
    this.getAllHeaderVoiceForApproval();
	this.getAllHeaderVoiceFromDLT();
    })
	//this.APIgetNewHeaderSummary();
  }
  getAllHeadersFilter(param1,fdate,todate){
    console.log("inside main function ");

    console.log("inside main function "+param1+"$$$"+fdate+"$$$$"+todate);
    this.hs.getAllHeadersFilter(param1,fdate,todate)
    .subscribe(r => {
      this.filterData = r;
      this.dataSource2 = r;
      console.log("12345 :", this.filterData);
    })

  }

  getAllUnapprovedRootHeaderFilter(param1,fdate,todate){
    console.log("inside main function ");

    console.log("inside main function "+param1+"$$$"+fdate+"$$$$"+todate);
    this.hs.getAllUnApprovedRootHeadersFilter(param1,fdate,todate)
    .subscribe(r => {
      this.filterData = r;
      this.dataSource1 = r;
      console.log("12345 :", this.filterData);
    })

  }

  getAllRootHeadersFilter(param1,fdate,todate){
    console.log("inside main function ");

    console.log("inside main function "+param1+"$$$"+fdate+"$$$$"+todate);
    this.hs.getAllRootHeadersFilter(param1,fdate,todate)
    .subscribe(r => {
      this.filterData = r;
      this.dataSource3 = r;
      console.log("12345 :", this.filterData);
    })

  }

  reset(){

    this.APIgetNewHeaderSummary();
    console.log("first reset function");

  }
  reset1(){

    this.getAllHeaderVoiceForApproval();
    console.log("second reset function");

  }
  reset2(){

    this.APIgetAllHeaderSummaries();
    console.log("first reset function");

  }

  _destroy() {}
}

export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}



